import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { LANGUAGE_CODES, LANGUAGE_LABELS } from 'src/shared/constants';
import { loadingPage } from 'src/store/pageLoader';

import styles from './LanguageSelector.module.scss';

const LanguageSelector = () => {
	const { i18n, t } = useTranslation();
	const dispatch = useDispatch<AppDispatch>();

	const changeLanguage = (languageCode: string) => {
		dispatch(loadingPage(500));
		i18n.changeLanguage(languageCode);
	};

	const getCurrentLanguage = () => {
		return i18n.language === LANGUAGE_CODES.ENGLISH
			? LANGUAGE_LABELS[LANGUAGE_CODES.ENGLISH]
			: LANGUAGE_LABELS[LANGUAGE_CODES.SPANISH];
	};

	return (
		<Dropdown className={styles.languageSelector}>
			<Dropdown.Toggle variant="outline-light" id="language_menu_dropdown" className={styles.dropdownToggle}>
				<FontAwesomeIcon icon="globe" className="me-2" />
				{getCurrentLanguage()}
			</Dropdown.Toggle>
			<Dropdown.Menu className={styles.dropdownMenu}>
				<Dropdown.Item
					id="language_option_spanish_menu_link"
					onClick={() => changeLanguage(LANGUAGE_CODES.SPANISH)}
					active={i18n.language === LANGUAGE_CODES.SPANISH}
					className={styles.dropdownItem}
				>
					{t('mainLayout.header.languageSelector.options.spanish')}
				</Dropdown.Item>
				<Dropdown.Item
					id="language_option_english_menu_link"
					onClick={() => changeLanguage(LANGUAGE_CODES.ENGLISH)}
					active={i18n.language === LANGUAGE_CODES.ENGLISH}
					className={styles.dropdownItem}
				>
					{t('mainLayout.header.languageSelector.options.english')}
				</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);
};

export default LanguageSelector;
